import { PickupCorporateConfigComponent } from "@/app/infrastructures/dependencies/PickupCorporateConfigComponent";
import { PickupCorporateConfig } from "@/domain/entities/PickupCorporateConfig";
import store from "@/store";
import { container } from "tsyringe";
import {
  Action,
  Module,
  Mutation,
  VuexModule,
  getModule
} from "vuex-module-decorators";
import { PickupCorporateConfigPresenter } from "../presenters/PickupCorporateConfigPresenter";

interface PickupCorporateConfigState {
  pickupCorporateConfig: PickupCorporateConfig;
  isLoading: boolean;
}

PickupCorporateConfigComponent.init();

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "pickup-corporate-config"
})
class PickupCorporateConfigStore extends VuexModule
  implements PickupCorporateConfigState {
  public pickupCorporateConfig: PickupCorporateConfig = new PickupCorporateConfig();
  public isLoading = false;

  @Action({ rawError: true })
  public async getPickupCorporateConfig(): Promise<PickupCorporateConfig> {
    const presenter = container.resolve(PickupCorporateConfigPresenter);
    const config = await presenter.getConfig();
    this.setPickupCorporateConfig(config);
    return config;
  }

  @Mutation
  public setPickupCorporateConfig(data: PickupCorporateConfig): void {
    this.pickupCorporateConfig = data;
  }

  @Mutation
  public setIsLoading(bool: boolean): void {
    this.isLoading = bool;
  }
}

export const PickupCorporateConfigController = getModule(
  PickupCorporateConfigStore
);
